import { http } from '@kunlun/dependencies';
import { format } from 'date-fns';

export enum TradeOrderAutoAllocInfoType {
  TRADE,
  PLAN
}

export interface TradeOrderAutoAllocInfoProxy {
  id: string | null;
  tradeOrderCode?: string | null;
  sellerId?: string | null;
  buyerId?: string | null;
  desc?: string | null;
  allocCount?: number | null;
  lastAllocTime?: Date | null;
  complete?: boolean | null;
  paused?: boolean | null;
  nextAllocTime?: Date | null;
  taskPriority?: number | null;
  relationCode?: string | null;
  runningDate?: Date | null;
  type?: TradeOrderAutoAllocInfoType | null;
  excludeIds?: string[] | null;
}

export interface TradeOrderAutoAllocInfoRecordProxy {
  id: string | null;
  tradeOrderAutoAllocInfoId?: string | null;
  tradeOrderAutoAllocInfo?: TradeOrderAutoAllocInfoProxy | null;
  desc?: string | null;
  allocCount?: number | null;
  runningDate?: Date | null;
  complete?: boolean | null;
  tradeOrderCode?: string | null;
  paused?: boolean | null;
  nextAllocTime?: Date | null;
  taskPriority?: number | null;
  relationCode?: string | null;
  type?: TradeOrderAutoAllocInfoType | null;
  queryStartDate: Date | null;
  queryTimeUnit: string | null;
}

export interface TradeOrderAutoAllocStatisticsData {
  date: string;
  num?: number;
}

export interface TradeOrderAutoAllocConsole {
  tradeOrderAutoAllocInfoRecords?: TradeOrderAutoAllocInfoRecordProxy | null;
  tradeOrderAutoAllocInfos?: TradeOrderAutoAllocInfoProxy | null;
  queryStartDate?: Date | null;
  queryEndDate?: Date | null;
  queryTimeUnit?: string | null;
  queryRelationOrderCode?: string | null;
  consumeInfo?: TradeOrderAutoAllocStatisticsData[] | null;
  completeInfo?: TradeOrderAutoAllocStatisticsData[] | null;
  enableTask?: boolean | null;
}

export const queryStatisticsData = async (params: TradeOrderAutoAllocConsole) => {
  let data = '{ ';
  const dataParams: string[] = [];
  if (params) {
    if (params.queryStartDate) {
      dataParams.push(`queryStartDate: "${formatDate(params.queryStartDate)}" `);
    }
    if (params.queryEndDate) {
      dataParams.push(`queryEndDate: "${formatDate(params.queryEndDate)}" `);
    }
    if (params.queryRelationOrderCode) {
      dataParams.push(`queryRelationOrderCode: "${params.queryRelationOrderCode}" `);
    }
  }
  data += dataParams.join(',') + '}';

  const gql = `
    query {
    	tradeOrderAutoAllocConsoleQuery {
    		queryStatisticsData(
          data: ${data}
        ) {
          enableTask
          queryTimeUnit
          queryStartDate
          queryEndDate
    			tradeOrderAutoAllocInfoRecords {
    				tradeOrderCode
    				type
    				relationCode
    				runningDate
    				nextAllocTime
    				complete
    				desc
    				taskPriority
    				paused
    				allocCount
    				id
    				tradeOrderAutoAllocInfo {
    					tradeOrderCode
    					type
    					relationCode
    					nextAllocTime
    					taskPriority
    					paused
    				}
    			}
    			tradeOrderAutoAllocInfos {
    				tradeOrderCode
    				type
    				relationCode
    				complete
    				paused
    				id
    			}
    			consumeInfo {
    				date
    				num
    			}
    			completeInfo {
    				date
    				num
    			}
    		}
    	}
    }
  `;

  const res = await http.query('libraCore', gql);
  return res.data?.tradeOrderAutoAllocConsoleQuery?.queryStatisticsData as TradeOrderAutoAllocConsole | undefined;
};

export const queryTradeOrderAutoAllocInfoRecordProxyPage = async (
  startDate?: Date | null,
  timeUnit?: string | null,
  nextId?: string | null,
  relationOrderCode?: string | null
) => {
  const gql = `
    query {
      tradeOrderAutoAllocInfoRecordProxyQuery {
        queryPage(
          page: {currentPage: 1, size: 15}
          queryWrapper: {rsql: "(1==1) and (1==1)", queryData: {queryStartDate: "${formatDate(
            startDate
          )}", queryTimeUnit:"${timeUnit}"${nextId ? ', nextId: "' + nextId + '"' : ''}, queryRelationOrderCode:"${
    relationOrderCode ? relationOrderCode : ''
  }"}}
        ) {
          content {
            id
            tradeOrderAutoAllocInfoId
            tradeOrderAutoAllocInfo {
              id
              tradeOrderCode
              sellerId
              buyerId
              desc
              allocCount
              lastAllocTime
              complete
              paused
              nextAllocTime
              taskPriority
              relationCode
              type
            }
            desc
            allocCount
            runningDate
            complete
            tradeOrderCode
            paused
            nextAllocTime
            taskPriority
            relationCode
            type
            queryStartDate
            queryTimeUnit
          }
        }
      }
    }
  `;

  const res = await http.query('libraCore', gql);
  return res.data?.tradeOrderAutoAllocInfoRecordProxyQuery?.queryPage?.content as
    | TradeOrderAutoAllocInfoRecordProxy[]
    | undefined;
};

export const formatDate: (date?: Date | null) => string = (date) => {
  return date ? format(date, 'YYYY-MM-DD HH:mm:ss') : '';
};

export const formatDate2: (date?: Date | null) => string = (date) => {
  return date ? format(date, 'YYYY/MM/DD HH:mm:ss') : '';
};
